import LayoutPage from '@/components/Layout/LayoutPage';
import { useConsultingEngagementsEnabled } from '@/features/consulting-engagements/featureFlag';
import EngagementsPage from '@/features/consulting-engagements/live/EngagementsPage';
import NotFoundPage from '@/pages/NotFoundPage';

/**
 * `/engagements` — the viewer's own engagements. Both sides land here as of
 * ENG-5609, when `myEngagementBuckets` became viewer-aware.
 *
 * The gate lives here rather than inside `EngagementsPage` so the dark case
 * renders the standalone 404 page — `NotFoundPage` brings its own `Layout`, and
 * nesting it inside `LayoutPage` would double-wrap the chrome.
 */
export default function EngagementsRoute(): JSX.Element {
  if (!useConsultingEngagementsEnabled()) return <NotFoundPage />;
  return (
    <LayoutPage showNav>
      <EngagementsPage />
    </LayoutPage>
  );
}
